import 'react-bootstrap-typeahead/css/Typeahead.css';
import './sass/App.scss';
import Main from './pages/Main'

import React, { useEffect } from 'react';

function App() {


  const TITLE = "BuscaTuAuto - Compra y Venta de Vehículos";
  useEffect(() => {
    document.title = TITLE;
  }, [TITLE]);
  
  return(<Main />)
}

export default App;
